import ListItemButton, { type ListItemButtonProps } from '@mui/material/ListItemButton';
import { createLink } from '@tanstack/react-router';
import { forwardRef } from 'react';

const ListItemButtonLinkInner = forwardRef<HTMLAnchorElement, ListItemButtonProps<'a'>>((props, ref) => {
    return <ListItemButton ref={ref} component="a" {...props} />;
});

ListItemButtonLinkInner.displayName = 'ListItemButtonLinkInner';

export const ListItemButtonLink = createLink(ListItemButtonLinkInner);
